<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <router-link :to="{ name: 'qris.list' }" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">QRIS Merchant Detail</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" class="pb-0" v-if="loadingApp == false">
            <div class="mt-2">
                <div class="section mb-2">
                    <!-- DRAFT -->
                    <div
                        class="alert alert-warning-custom mb-2"
                        v-if="qris_merchant_data.status == 'DRAFT'"
                    >
                        <h5 class="mt-1" style="font-weight: bold">
                            ⚠️ QRIS ini belum aktif/terbit
                        </h5>
                        <p
                            class="text-secondary mb-1"
                            style="font-size: 12px; line-height: 18px"
                        >
                            Selesaikan pendaftaran QRIS Merchant agar QRIS Anda
                            bisa segera terbit. Klik tombol dibawah ini untuk
                            menyelesaikan pendaftaran!
                        </p>
                        <a
                            target="_blank"
                            :href="
                                qris_merchant_data.qris_providers
                                    .url_registration
                            "
                            class="btn btn-primary btn-block"
                        >
                            Lanjutkan Pendaftaran
                        </a>
                    </div>
                    <!-- PROCESS -->
                    <div
                        class="alert alert-warning-custom mb-2"
                        v-else-if="qris_merchant_data.status == 'PROCESS'"
                    >
                        <h5 class="mt-1" style="font-weight: bold">
                            🔃 QRIS ini dalam proses validasi dan penerbitan
                        </h5>
                        <p
                            class="text-secondary mb-1"
                            style="font-size: 12px; line-height: 18px"
                        >
                            Proses validasi dan penerbitan membutuhkan proses 7
                            hari kerja, mohon kesediannya menunggu. Kami akan
                            memberikan notifikasi melalui aplikasi jika
                            pendaftaran Anda sudah diterima atau butuh revisi
                        </p>
                    </div>
                    <!-- REJECT -->
                    <div
                        class="alert alert-danger-custom mb-2"
                        v-else-if="qris_merchant_data.status == 'REJECT'"
                    >
                        <h5 class="mt-1" style="font-weight: bold">
                            ⛔ Pendaftaran ditolak, butuh revisi
                        </h5>
                        <p
                            class="text-secondary mb-1"
                            style="font-size: 12px; line-height: 18px"
                        >
                            Pendaftaran QRIS Merchant Anda ditolak, lakukan
                            revisi untuk melakukan pengajuan kembali.
                        </p>
                        <a
                            target="_blank"
                            :href="
                                qris_merchant_data.qris_providers
                                    .url_registration
                            "
                            class="btn btn-primary btn-block"
                        >
                            Revisi Pendaftaran
                        </a>
                    </div>
                    <!-- BLOCKED -->
                    <div
                        class="alert alert-danger-custom mb-2"
                        v-else-if="qris_merchant_data.status == 'BLOCKED'"
                    >
                        <h5 class="mt-1" style="font-weight: bold">
                            ⛔ QRIS diblokir
                        </h5>
                        <p
                            class="text-secondary mb-1"
                            style="font-size: 12px; line-height: 18px"
                        >
                            QRIS Merchant Anda diblokir dari penyedia, silahkan
                            hubungi Customer Service untuk informasi lebih
                            lanjut
                        </p>
                    </div>
                </div>
                <div class="section">
                    <div class="mb-2">
                        <div class="list-text">
                            <dt>ID Merchant (NMID)</dt>
                            <dd>
                                {{
                                    qris_merchant_data.merchant_id
                                        ? qris_merchant_data.merchant_id
                                        : '-'
                                }}
                            </dd>
                        </div>
                        <div class="list-text">
                            <dt>Nama Merchant</dt>
                            <dd>
                                {{ qris_merchant_data.merchant_name }}
                            </dd>
                        </div>
                        <div class="list-text">
                            <dt>Provider Penyedia</dt>
                            <dd>
                                {{ qris_merchant_data.qris_providers.name }}
                            </dd>
                        </div>
                        <div class="list-text">
                            <dt>Biaya MDR (Per Transaksi)</dt>
                            <dd>
                                Berdasarkan nominal transaksi :
                                <ul>
                                    <li
                                        v-for="item in qris_merchant_data
                                            .qris_providers.qris_payment_fees"
                                        :key="item.id"
                                    >
                                        <div v-if="item.max_amount > 0">
                                            <span
                                                >Rp{{
                                                    item.min_amount | rupiah
                                                }}</span
                                            >
                                            s.d
                                            <span>
                                                Rp
                                                {{
                                                    item.max_amount | rupiah
                                                }}</span
                                            >
                                            =
                                            {{
                                                item.fee_type == 'FIXED'
                                                    ? 'Rp'
                                                    : ''
                                            }}
                                            {{ item.fee_value
                                            }}{{
                                                item.fee_type == 'PERCENT'
                                                    ? '%'
                                                    : ''
                                            }}
                                        </div>
                                        <div v-else>
                                            ≥
                                            <span
                                                >Rp{{
                                                    item.min_amount | rupiah
                                                }}</span
                                            >
                                            = {{ item.fee_value }}%
                                        </div>
                                    </li>
                                </ul>
                            </dd>
                        </div>
                        <div class="list-text">
                            <dt>Status</dt>
                            <dd>
                                <span
                                    class="badge badge-grey-custom pr-2 pl-2"
                                    v-if="qris_merchant_data.status == 'DRAFT'"
                                    >{{ qris_merchant_data.status }}</span
                                >
                                <span
                                    class="badge badge-warning-custom pr-2 pl-2"
                                    v-else-if="
                                        qris_merchant_data.status == 'PROCESS'
                                    "
                                    >{{ qris_merchant_data.status }}</span
                                >
                                <span
                                    class="badge badge-success-custom pr-2 pl-2"
                                    v-else-if="
                                        qris_merchant_data.status == 'ACTIVE'
                                    "
                                    >{{ qris_merchant_data.status }}</span
                                >
                                <span
                                    class="badge badge-danger-custom pr-2 pl-2"
                                    v-else-if="
                                        qris_merchant_data.status == 'REJECT'
                                    "
                                    >{{ qris_merchant_data.status }}</span
                                >
                                <span
                                    v-else
                                    class="badge badge-info-custom pr-2 pl-2"
                                    >{{ qris_merchant_data.status }}</span
                                >
                            </dd>
                        </div>
                    </div>
                </div>
                <div class="section full mb-2">
                    <ul class="listview image-listview inset">
                        <li>
                            <div class="item">
                                <div class="in">
                                    <div>
                                        Atur Sebagai Default
                                        <footer>
                                            QRIS akan muncul di halaman utama
                                            menu QRIS
                                        </footer>
                                    </div>
                                    <div class="custom-control custom-switch">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="toggleDefault"
                                            v-model="
                                                qris_merchant_data.is_default
                                            "
                                            @change="changeToggleDefault"
                                        />
                                        <label
                                            class="custom-control-label"
                                            for="toggleDefault"
                                        ></label>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="item">
                                <div class="in">
                                    <div>
                                        <ion-icon name="flash"></ion-icon> Fast
                                        Settlement
                                        <footer>
                                            Pencairan Saldo QRIS dipercepat<br />Biaya
                                            Percepatan
                                            {{
                                                qris_merchant_data.fee_fast_settlement
                                            }}%
                                        </footer>
                                    </div>
                                    <div class="custom-control custom-switch">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="toggleFastSettlement"
                                            v-model="
                                                qris_merchant_data.fast_settlement
                                            "
                                            @change="changeToggleFastSettlement"
                                        />
                                        <label
                                            class="custom-control-label"
                                            for="toggleFastSettlement"
                                        ></label>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- dialog Clear Cache -->
        <Dialog
            ref="dialog_alert_coming"
            :loading="false"
            :title="'Informasi'"
            @confirm="showAlertComing('hide')"
            :icon="'warning'"
        >
            <span class="text-standar"
                >Fitur ini masih dalam pengembangan dan akan segera tersedia,
                saat fitur ini sudah tersedia akan kami informasikan.</span
            >
        </Dialog>
    </div>
</template>
<script>
    // import $axios from './../../api.js';
    import { mapActions, mapState } from 'vuex';
    export default {
        data() {
            return {
                loading: {
                    content: false,
                },
                affiliate_id: '',
                loadingApp: false,
                loadingActionSheet: false,
                loadingButton: false,
            };
        },
        created() {
            this.loadingApp = true;
            this.getQrisMerchantDetail(this.$route.params.id).then(() => {
                this.loadingApp = false;
            });
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
            ...mapState('qrisMerchant', {
                qris_merchant_data: state => state.qris_merchant_data,
            }),
        },
        methods: {
            ...mapActions('qrisMerchant', [
                'getQrisMerchantDetail',
                'updateToggleFastSettlement',
                'updateToggleDefault',
            ]),
            changeToggleFastSettlement() {
                this.updateToggleFastSettlement(this.$route.params.id)
                    .then(() => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: 'Fast Settlement telah diubah',
                            tipe: 'default',
                            icon: 'success',
                        });
                    })
                    .catch(error => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.response.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                    });
            },
            changeToggleDefault() {
                this.updateToggleDefault(this.$route.params.id).catch(error => {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message: error.data.responseMessage,
                        tipe: 'default',
                        icon: 'danger',
                    });
                });
            },
        },

        mounted() {},
    };
</script>
<style>
    .table-min th,
    .table-min td {
        padding: 0.5rem 0.75rem 0.5rem 0.75rem;
    }
    .list-text {
        border-bottom: 1px solid #dee2e6;
        margin-bottom: 8px;
    }
</style>
